import { render, staticRenderFns } from "./AffiliateAdjustDialog.vue?vue&type=template&id=1f28020b&"
import script from "./AffiliateAdjustDialog.vue?vue&type=script&lang=js&"
export * from "./AffiliateAdjustDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports